export default __webpack_public_path__ + "static/media/boy.9e16116b.png";